export var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["PENDING"] = "PENDING";
    OrderPaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    OrderPaymentStatus["PAID"] = "PAID";
    OrderPaymentStatus["REFUND_REQUIRED"] = "REFUND_REQUIRED";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
